import React, { Component, PureComponent, Fragment } from 'react'
import { Popup, Button } from 'semantic-ui-react'

export default function Prompt(props) {
  let { question, onAction, content } = props

  let el = (
    <div className="prompt">
      <div className="prompt-question">{question}</div>
      <div className="prompt-button">
        <Button size="tiny" content="Kyllä" onClick={e => e.preventDefault() & onAction()} color="red" />
      </div>
    </div>
  )

  return (
    <Popup
      trigger={
        <a href="#" onClick={e => e.preventDefault()}>
          {content}
        </a>
      }
      content={el}
      on="click"
      position="top right"
    />
  )
}
